/***
* 前端公共方法文件 *
***/
import { getSessionStorage } from '@/utils/auth'

// 判断是否是小程序环境（区分小程序和公众号）
export function isMiniProgram() {
  // 方式1: 检查微信小程序环境标识（最准确）
  if (typeof window !== 'undefined' && window.__wxjs_environment === 'miniprogram') {
    return true
  }
  
  // 方式2: 通过wx.miniProgram.getEnv判断（异步，但可以通过同步检查wx.miniProgram是否存在）
  // 注意：wx.miniProgram在公众号中不存在，只在小程序中存在
  if (typeof wx !== 'undefined' && wx.miniProgram) {
    // 进一步确认：如果wx.miniProgram存在，通常就是小程序环境
    // 但为了更准确，可以尝试调用getEnv（异步，这里只做存在性检查）
    return true
  }
  
  // 方式3: 检查userAgent（备用方案，但可能不够准确）
  const ua = navigator.userAgent.toLowerCase()
  if (ua.indexOf('miniprogram') > -1) {
    return true
  }
  
  return false
}

// 过滤对象中 字段为'', undefined, null 的字段, 生成一个新的对象, 用于调用接口.
export function filterApiParams (values) {
  const params = { ...values }
  for (const key in params) {
    if (params[key] === '' || params[key] === undefined || params[key] === null) {
      delete params[key]
    }
  }
  return params
}
// 图片转base64
export function getBase64Image (img) {
  const canvas = document.createElement('CANVAS')
  canvas.width = img.width
  canvas.height = img.height
  const ctx = canvas.getContext('2d')
  ctx.drawImage(img, 0, 0, img.width, img.height)
  const ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase()
  const dataURL = canvas.toDataURL('image/' + ext)
  return dataURL
}

// 获取当前日期（年月日时分秒）
export function getCurrentDate() {
  var date = new Date()
  var y = date.getFullYear()
  var m = date.getMonth() + 1
  m = m < 10 ? ('0' + m) : m
  var d = date.getDate()
  d = d < 10 ? ('0' + d) : d
  var h = date.getHours()
  h = h < 10 ? ('0' + h) : h
  var minute = date.getMinutes()
  minute = minute < 10 ? ('0' + minute) : minute
  var second = date.getSeconds()
  second = second < 10 ? ('0' + second) : second
  return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
}
